module.exports = __webpack_public_path__ + "img/Jinlin-power.c887367e.png";